export const dataTab = [
    {
        text: 'INSTALAÇÃO',
        value: '1',
        exist: false,
        listScheduling: []
    },
    {
        text: 'DESINSTALAÇÃO',
        value: '2',
        exist: false,
        listScheduling: []
    },
    {
        text: 'VISTORIA',
        value: '3',
        exist: false,
        listScheduling: []
    },
    {
        text: 'REVISÃO',
        value: '4',
        exist: false,
        listScheduling: []
    },
    {
        text: 'CONCLUÍDOS',
        value: '5',
        exist: true,
        listScheduling: []
    }
];
